import { render, staticRenderFns } from "./AdditionalBlock.vue?vue&type=template&id=46b95315&scoped=true&"
import script from "./AdditionalBlock.vue?vue&type=script&lang=js&"
export * from "./AdditionalBlock.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalBlock.vue?vue&type=style&index=0&id=46b95315&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b95315",
  null
  
)

export default component.exports